import { activityApi } from "../api/activity";
import { loadDashboardTutorialState, reportDashboardTutorialMetric } from "./dashboardTutorial";

// El tutorial formal usa el puente existente; ayuda consultada por cuenta propia
// también queda medida, con un identificador de sesión efímero y SOLO códigos estructurales.
const ALLOWED_HELP_EVENTS = Object.freeze({
  movements_orientation_opened: { action: "onboarding_movements_orientation_opened", stage: "movements_orientation" },
  historical_strategy_reviewed: { action: "onboarding_historical_strategy_reviewed", stage: "historical_data" },
  cash_fee_preview_opened: { action: "onboarding_cash_fee_preview_opened", stage: "initial_finance" },
});
const ALLOWED_HISTORY = new Set(["fresh_start", "controlled_migration"]);

export function createOnboardingHelpSession() {
  return `help-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function reportOnboardingHelpEvent(project, metricType, detail = {}, helpSessionId = "") {
  const config = ALLOWED_HELP_EVENTS[metricType];
  if (!config || !project) return;
  const safeDetails = metricType === "historical_strategy_reviewed"
    ? { reasonCode: ALLOWED_HISTORY.has(detail.reasonCode) ? detail.reasonCode : "unknown" }
    : { sourceType: metricType === "cash_fee_preview_opened" ? "cash_register" : "movement_screen" };
  if (loadDashboardTutorialState(project)?.active) {
    reportDashboardTutorialMetric(project, metricType, safeDetails);
    return;
  }
  // WebProfit usa HashRouter: el pathname visible del browser suele ser "/".
  // Conservar sólo la ruta dentro de #/, descartando querys con notas, montos y referencias.
  const hashPath = typeof window !== "undefined" && window.location.hash.startsWith("#/")
    ? window.location.hash.slice(1).split("?")[0].split("#")[0]
    : "";
  const path = hashPath || (typeof window === "undefined" ? "" : window.location.pathname);
  const sessionId = /^[a-zA-Z0-9-]{8,90}$/.test(String(helpSessionId))
    ? helpSessionId : createOnboardingHelpSession();
  activityApi.trackPanel({
    action: config.action,
    projectId: String(project.id || project._id || ""),
    projectSlug: String(project.slug || ""),
    path,
    journey: { channel: "panel", sessionId, path, step: 0 },
    metadata: {
      analyticsOnly: true,
      telemetryVersion: 2,
      tutorialKey: "self_service",
      tutorialSessionId: sessionId,
      stageKey: config.stage,
      stepIndex: 0,
      ...safeDetails,
    },
  }).catch(() => null);
}
